import countries from "i18n-iso-countries";
import plLocale from "i18n-iso-countries/langs/pl.json";

countries.registerLocale(plLocale);

const names = countries.getNames("pl", { select: "official" });

export const countryItems = (() => {
  const list = Object.entries(names)
    .map(([value, name]) => ({ value, name }))
    .sort((a, b) => a.name.localeCompare(b.name, "pl"));
  const polandIndex = list.findIndex((c) => c.value === "PL");
  if (polandIndex > -1) {
    const [poland] = list.splice(polandIndex, 1);
    list.unshift(poland);
  }
  return list;
})();

export const toCountryCode = (value) => {
  if (!value) return "PL";
  const v = String(value).trim();
  if (/^[A-Za-z]{2}$/.test(v) && countries.getName(v.toUpperCase(), "pl")) {
    return v.toUpperCase();
  }
  return countries.getAlpha2Code(v, "pl") || "PL";
};
